import update from 'immutability-helper';
import { DESC } from '@utils/table/constants';
import * as types from './types';

export const ORIGIN_FUNCDATA = {
  columnKey: '',
  searchText: {},
  order: DESC,
  orderKey: '',
};
export const CONST_STATE = {
  data: [], // table data
  columns: [], // table columns
  query: {},
  funcData: { ...ORIGIN_FUNCDATA },
  selectedMetrics: [],
  anchoredMetrics: {},
  isFetching: false,
  errorCode: 0,
  errorMsg: '',
  exceedTimeLimit: false,
  dataType: 'dimension',
};

const initialState = { trends: { ...CONST_STATE } };

const reducerMap = Object.create(null);

reducerMap[types.CHANGE_FUNC_DATA] = (state, action) => update(state, {
  [action.name]: {
    funcData: {
      $set: update(state[action.name].funcData, { $merge: action.newFuncData }),
    },
  },
});

reducerMap[types.CHANGE_TIME_LIMIT] = (state, action) => update(state, {
  [action.name]: {
    exceedTimeLimit: {
      $set: action.limit,
    },
  },
});

reducerMap[types.GET_SCAN_DATA] = (state, action) => update(state, {
  [action.name]: {
    isFetching: { $set: true },
  },
});
reducerMap[types.GET_SCAN_DATA_SUCCESSFUL] = (state, action) => update(state, {
  [action.name]: {
    data: { $set: action.data },
    isFetching: { $set: false },
    errorCode: { $set: 0 },
    errorMsg: { $set: '' },
  },
});

reducerMap[types.GET_SCAN_DATA_FAIL] = (state, action) => update(state, {
  [action.name]: {
    isFetching: { $set: false },
    errorCode: { $set: action.errorCode },
    errorMsg: { $set: action.errorMsg },
  },
});

reducerMap[types.UPDATE_TABLE_COLUMNS] = (state, action) => update(state, {
  [action.name]: {
    columns: {
      $set: action.newColumns,
    },
  },
});

reducerMap[types.UPDATE_METRIC_ANCHOR] = (state, action) => {
  const originalValue = state[action.name].anchoredMetrics[action.metric] || false;
  return update(state, {
    [action.name]: {
      anchoredMetrics: {
        $set: { ...state[action.name].anchoredMetrics, [action.metric]: !originalValue },
      },
    },
  });
};

reducerMap[types.SET_VIEWER_SESSIONS_PARAMS] = (state, action) => update(state, {
  [action.name]: {
    $merge: action.params,
  },
});

reducerMap[types.SET_DATA_TYPE] = (state, action) => update(state, {
  [action.name]: {
    dataType: {
      $set: action.dataType,
    },
  },
});

reducerMap[types.ADD_TABLE_DATA] = (state, action) => update(state, {
  [action.code]: {
    $set: { ...CONST_STATE },
  },
});

reducerMap[types.SAVE_SCAN_QUERY] = (state, action) => update(state, {
  trends: {
    [action.name]: {
      $set: action.body,
    },
  },
});

// eslint-disable-next-line max-len
const viewerSessions = (state = initialState, action) => (reducerMap[action.type] ? reducerMap[action.type](state, action) : state);

export default viewerSessions;
